/** Escape HTML, then apply light markdown used by the Support Bot. */
export function formatChatMessageHtml(text: string): string {
  let html = text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

  // Linkify before inserting other tags so path regex cannot match "</strong>" etc.
  html = html.replace(/(https?:\/\/[^\s]+)/g, match => {
    return `<a href="${match}" class="chat-link" target="_blank" rel="noopener noreferrer">${match}</a>`;
  });
  html = html.replace(/(^|[\s(])(\/[\w-]+)/g, (_, prefix: string, path: string) => {
    return `${prefix}<a href="${path}" class="chat-link" target="_self">${path}</a>`;
  });

  html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  html = html.replace(/\n/g, '<br />');

  return html;
}
